import { GraphSchema } from '@camelot/server';

import { BillingRow, billingRowProps } from '../../../../common/services/dto/row';

export interface QuotationRow extends BillingRow {}

export const quotationRowFields: Array<keyof QuotationRow> = [...billingRowProps, 'documentIds'];

export const quotationRowProps = new GraphSchema<QuotationRow>(quotationRowFields);
